var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[(_vm.isNoData)?_c('no-data-chart'):_c('div',{class:_vm.$style.chartBox,style:({ height: _vm.height }),attrs:{"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }